<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Share Planogram</h4>
  <button type="button" class="btn btn-link p-0" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <h5>Shared Users</h5>
    <table class="table table-bordered align-middle">
      <thead>
        <tr>
          <th>Name</th>
          <th>Surname</th>
          <th>Email</th>
          <th>Access Type</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of sharedUsers">
          <td>{{ user.name }}</td>
          <td>{{ user.surname }}</td>
          <td>{{ user.email }}</td>
          <td>
            <select
              class="form-select form-select-sm"
              [(ngModel)]="user.shareType"
              (change)="updateAccess(user, user.shareType)"
            >
              <option [ngValue]="0">View</option>
              <option [ngValue]="1">Edit</option>
            </select>
          </td>
          <td>
            <button class="btn btn-sm btn-outline-danger" (click)="removeUser(user)">
              <i class="bi bi-trash"></i> Remove
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <hr />

  <h5>Add User</h5>
  <div class="d-flex gap-2 mb-3">
    <input type="text" class="form-control" placeholder="Name" [(ngModel)]="newUser.name" />
    <input type="text" class="form-control" placeholder="Surname" [(ngModel)]="newUser.surname" />
    <input type="email" class="form-control" placeholder="Email" [(ngModel)]="newUser.email" />
    <select class="form-select" [(ngModel)]="newUser.shareType">
      <option [ngValue]="0">View</option>
      <option [ngValue]="1">Edit</option>
    </select>
    <button class="btn btn-primary" (click)="addUser()">Add</button>
  </div>
</div>

<div class="modal-footer d-flex justify-content-between">
  <div class="d-flex gap-2 align-items-center">
    <div class="d-flex gap-2 align-items-center form-switch border border-dark p-2 py-3">
      <input
        class="form-check-input m-0"
        type="checkbox"
        id="collabToggle"
        [checked]="shareSettings?.collaborationEnabled"
        (change)="toggleCollaboration()"
      />
      <label class="form-check-label m-0" for="collabToggle">
        Collaboration Enabled
      </label>
    </div>
    <div class="d-flex align-items-center gap-2 border border-dark p-2">
      <label class="form-label m-0">Feedback Deadline:</label>
      <input
        type="datetime-local"
        class="form-control w-auto m-0"
        [value]="shareSettings?.feedbackDeadline ? (shareSettings?.feedbackDeadline | date: 'yyyy-MM-ddTHH:mm') : ''"
        (change)="setDeadline($event.target)"
      />
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="clearDeadline()"
      >
        Clear Deadline
      </button>
    </div>
  </div>
  <div class="d-flex gap-2">
    <button type="button" class="btn btn-warning" (click)="synchronize()">Synchronize</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Close</button>
  </div>
</div>